import router from './router'
import saleMessages from './localization'

export default {
  router,
  localization: saleMessages,
}
